module.exports = __webpack_public_path__ + "media/images/app/about/anjali-3f0142be34bd58d6bcb8c84a482a3613.webp";